import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6a57ee11&scoped=true&lang=pug&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57ee11",
  null
  
)

export default component.exports